<template>
  <div class="wrapTabs">
    <v-tabs v-model="tab" color="green" class="custom-tab" :items="false" align-tabs="center">
      <v-tab :value="item.value" v-for="(item, index) in tabs" :key="index"
        >{{ item.label }}

        <v-badge color="pink" :content="getMesageTitol" v-if="index == 2 && getMesageTitol > 0">
        </v-badge>
      </v-tab>
    </v-tabs>
    <!-- <div style="text-align: right; overflow: hidden" v-if="getRoute() == 'courseEdit'">
      <v-btn @click.stop="submit1" style="width: 100px; margin-right: 52px"> 提交 </v-btn>
    </div> -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <courseDetail
          :tabIndex="tab"
          v-if="tab == 0"
          ref="courseDetail"
          :routeData="routeData1"
        ></courseDetail>
      </v-tab-item>

      <v-tab-item>
        <coursediscussion
          @quertTotal="quertTotal"
          :tabIndex="tab"
          :routeData="routeData"
          v-if="tab == 1"
        ></coursediscussion>
      </v-tab-item>

      <v-tab-item>
        <speakDiscussion :tabIndex="tab" :routeData="routeData" v-if="tab == 2"></speakDiscussion>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
  <script>
import courseDetail from './courseDetail.vue';
import coursediscussion from './courseDiscussion.vue';
import speakDiscussion from './speakDiscussion';
import { queryMessage } from '@/api/simulation';
export default {
  //课程讨论
  components: {
    courseDetail,
    coursediscussion,
    speakDiscussion,
  },
  props: {
    routeData: {
      default: null,
      type: Object,
    },
  },
  watch: {
    routeData: {
      handler(news) {
        this.routeData1 = news;
        this.setMessageTitol(news);
      },
    },
  },
  data() {
    return {
      routeData1: {},
      getMesageTitol: 0,
      tabs: [
        {
          label: '课程详情',
          value: '0',
        },
        {
          label: '课程评价',
          value: '1',
        },
        {
          label: '话题讨论',
          value: '2',
        },
      ],
      tab: 0,
    };
  },
  computed: {},
  created() {},
  methods: {
    quertTotal() {
      this.setMessageTitol();
    },
    setMessageTitol(news) {
      let params = {
        courseId: this.routeData._id || news._id || '',
      };
      queryMessage(params).then(res => {
        this.getMesageTitol = res.data.length;
        this.$emit('getMesageTitol',this.getMesageTitol)
      });
    },
    getRoute() {
      // courseView //查看    courseEdit 编辑
      let route = null;
      if (this.$route.query && this.$route.query.courseType) {
        route = this.$route.query.courseType;
      }
      return route;
    },
  },
};
</script>
  <style scoped>
.wrapTabs {
  width: 60%;
  height: auto;
  float: left;
  /* border-radius: 10px; */
  /* margin-top: 20px; */
  border-right: 1px solid #cacaca;
  padding: 20px 0 0 0;
}

.v-slide-group__content .v-tab {
  font-size: 18px !important;
}

.v-slide-group__content >>> .v-tab,
.v-tab--active {
  color: #000 !important;
  font-weight: bold;
}
>>> .v-slide-group__content .v-tab:not(.v-tab--active) {
  color: #575757 !important;
}

>>> .v-slide-group__content .v-tabs-slider-wrapper {
  display: none;
}
/* 媒体查询 - 针对小屏幕设备 */
/* @media (max-width: 1320px) {
  .wrapTabs{
    width: 40%;
  }
} */

@media (max-width: 950px) {
  .wrapTabs {
    width: 100% !important;
    float: none;
  }
  .wrapTabs{
    border:none
  }
  /* .wrap .lbox{
    width: 100% !important;
    margin-bottom: 20px;
  }
  // .wrap .rbox{
  //   width: 100% !important;
  //   float: none !important;
  // } */
}

@media (max-width: 440px) {
  .v-slide-group__prev {
    display: none !important;
  }

  .v-slide-group__content .v-tab {
    padding: 0px !important;
  }
}
</style>
  